import { useNavigateBack } from '@exam-management/common/hooks';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { useParams } from '@exam-management/router';

import { QContentCreateHeader } from '../../components';

export default function QContentCreateSingleHeader() {
  const { qBankStructureInformation } = useQBankStructure();
  const { structureId } = useParams('/qbank-structures/:structureId');

  const { handleBack } = useNavigateBack({
    fallbackPath: '/qbank-structures/:structureId/qcontents',
    matchPatterns: '/qbank-structures/:structureId/qcontents',
    fallbackParams: { structureId },
  });

  return (
    <QContentCreateHeader
      title='Add New Single Question'
      courseID={qBankStructureInformation.code.toString()}
      qbsName={qBankStructureInformation.name}
      onBack={handleBack}
    />
  );
}
